import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { finalize, Subscription } from 'rxjs';

import { BookingStore } from '../../../../pages/booking/store';
import { AppService } from '../../../services/app';
import { FlightHttpService } from '../../../services/http';

import { BookingRuleEnum } from '../../../enums';
import {
  BookingRuleDetails,
  SegmentFlights,
  GetPriceTermRequest,
} from '../../../models/api/flight';

@Component({
  selector: 'app-ticket-rules',
  templateUrl: './ticket-rules.component.html',
  standalone: true,
  imports: [NgTemplateOutlet],
})
export class TicketRulesComponent implements OnInit {
  private _subscriptions$: Subscription[] = [];
  private _bookingStore = inject(BookingStore);
  private _appService = inject(AppService);
  private _flightHttp = inject(FlightHttpService);
  readonly selectFlightState = this._bookingStore.selectFlight;
  readonly isLoadingRules = signal(false);
  readonly bookingRules = signal<Array<BookingRuleDetails>>([]);
  readonly BookingRuleEnum = BookingRuleEnum;

  // Get unique fare classes and return segment element
  // readonly fareClassSegments = computed(() => {
  //   let result: SegmentFlights[] = [];
  //   const selectedFlight = this._bookingStore.selectFlight.selectedFlight();
  //   const selectedRoundTripFlight =
  //     this._bookingStore.selectFlight.selectedRoundTripFlight();
  //   const selectedSmartCombo =
  //     this._bookingStore.selectFlight.selectedSmartCombo();

  //   if (selectedFlight) {
  //     result.push(...selectedFlight.flights[0].segments);
  //   }
  //   if (selectedRoundTripFlight) {
  //     result.push(...selectedRoundTripFlight.flights[0].segments);
  //   }
  //   if (selectedSmartCombo) {
  //     result.push(...selectedSmartCombo.flights.flatMap((f) => f.segments));
  //   }

  //   result = result.filter(
  //     (obj, index, self) =>
  //       self.findIndex((i) => i.fareClass === obj.fareClass) === index,
  //   );
  //   return result;
  // });

  readonly getUniqueFareClassSegments = (segments: SegmentFlights[]) => {
    return segments.filter(
      (obj, index, self) =>
        self.findIndex((i) => i.fareClass === obj.fareClass) === index,
    );
  };
  readonly flightBookingRules = computed(() => {
    const selectedFlight = this._bookingStore.selectFlight.selectedFlight();
    if (selectedFlight) {
      return this.getUniqueFareClassSegments(
        selectedFlight.flights[0].segments,
      ).map((s) => {
        const bookingRules = this._bookingStore.getSelectFlightConditions(
          selectedFlight.airlineRequest,
          s.fareClass,
        );
        return {
          segment: s,
          bookingRules,
        };
      });

      // return this.bookingRules().filter((r) =>
      //   selectedFlight.flights[0].segments
      //     .map((s) => s.fareClass)
      //     .includes(r.segment.fareClass),
      // );
    }

    const selectedSmartCombo =
      this._bookingStore.selectFlight.selectedSmartCombo();
    if (selectedSmartCombo) {
      return this.getUniqueFareClassSegments(
        selectedSmartCombo.flights[0].segments,
      ).map((s) => {
        const bookingRules = this._bookingStore.getSelectFlightConditions(
          selectedSmartCombo.airlineRequest,
          s.fareClass,
        );
        return {
          segment: s,
          bookingRules,
        };
      });

      // return this.bookingRules().filter((r) =>
      //   selectedSmartCombo.flights[0].segments
      //     .map((s) => s.fareClass)
      //     .includes(r.segment.fareClass),
      // );
    }

    return undefined;
  });
  readonly roundTripFlightBookingRules = computed(() => {
    const selectedRoundTripFlight =
      this._bookingStore.selectFlight.selectedRoundTripFlight();
    if (selectedRoundTripFlight) {
      return this.getUniqueFareClassSegments(
        selectedRoundTripFlight.flights[0].segments,
      ).map((s) => {
        const bookingRules = this._bookingStore.getSelectFlightConditions(
          selectedRoundTripFlight.airlineRequest,
          s.fareClass,
        );
        return {
          segment: s,
          bookingRules,
        };
      });

      // return this.bookingRules().filter((r) =>
      //   selectedRoundTripFlight.flights[0].segments
      //     .map((s) => s.fareClass)
      //     .includes(r.segment.fareClass),
      // );
    }

    const selectedSmartCombo =
      this._bookingStore.selectFlight.selectedSmartCombo();
    if (selectedSmartCombo) {
      return this.getUniqueFareClassSegments(
        selectedSmartCombo.flights[1].segments,
      ).map((s) => {
        const bookingRules = this._bookingStore.getSelectFlightConditions(
          selectedSmartCombo.airlineRequest,
          s.fareClass,
        );
        return {
          segment: s,
          bookingRules,
        };
      });

      // return this.bookingRules().filter((r) =>
      //   selectedSmartCombo.flights[1].segments
      //     .map((s) => s.fareClass)
      //     .includes(r.segment.fareClass),
      // );
    }
    return undefined;
  });
  readonly smartComboBookingRules = computed(() => {
    const selectedSmartCombo =
      this._bookingStore.selectFlight.selectedSmartCombo();
    if (selectedSmartCombo) {
      return this.getUniqueFareClassSegments(
        selectedSmartCombo.flights.flatMap((f) => f.segments),
      ).map((s) => {
        const bookingRules = this._bookingStore.getSelectFlightConditions(
          selectedSmartCombo.airlineRequest,
          s.fareClass,
        );
        return {
          segment: s,
          bookingRules,
        };
      });

      // return this.bookingRules().filter((r) =>
      //   selectedSmartCombo.flights.some((f) =>
      //     f.segments.map((s) => s.fareClass).includes(r.segment.fareClass),
      //   ),
      // );
    }
    return undefined;
  });

  ngOnInit(): void {
    // this.getDetails();
  }

  // getDetails() {
  //   let agCode = this._appService.getAgentCode('Booking');
  //   if (this._bookingStore.selectFlight.code()) {
  //     agCode = this._bookingStore.selectFlight.code()!;
  //   }

  //   let loadingCount = 0;
  //   this.fareClassSegments().forEach((s) => {
  //     const request: GetPriceTermRequest = {
  //       agCode: agCode,
  //       airline: s.airline,
  //       groupClass: s.groupClass,
  //       fareClass: s.fareClass,
  //     };

  //     loadingCount++;
  //     this.isLoadingRules.set(true);
  //     this._subscriptions$.push(
  //       this._flightHttp
  //         .getPriceTerm(request)
  //         .pipe(
  //           finalize(() => {
  //             loadingCount--;
  //             if (loadingCount <= 0) {
  //               this.isLoadingRules.set(false);
  //             }
  //           }),
  //         )
  //         .subscribe((res) => {
  //           if (!res.message) {
  //             this.bookingRules.set([
  //               ...this.bookingRules(),
  //               {
  //                 segment: s,
  //                 bookingRules: res.bookingRules,
  //               },
  //             ]);
  //           }
  //         }),
  //     );
  //   });
  // }
}
